import AccountLayout from '@/views/layout/account';
import AccountPage from '@/views/pages/account/account';

export const accountRoutes = [
    {
        path: '/account',
        component: AccountLayout,
        meta: {middleware: 'auth'},
        children: [
            {path: '', component: AccountPage, meta: {middleware: 'auth'}},
        ],
    },
];
